import {showModalNotification} from '../common/modal-notification';
import messages from '../messages/common';

const message = messages();
const errorSending = '.error-sending';
const errorSelector = 'invalid';
const elemErrorSelector = 'error';

/**
 * Show error from form
 * @param form
 */
let showError = (form) => {
    let elem = $(errorSending, form);

    if (elem.length) {
        elem.html(
            `<div class="error-sending__body">${message.textRequestError}</div>`
        );

        return;
    }

    showModalNotification({
        title: message.textError,
        body: message.textRequestError,
    });
};

/**
 * Clear errors
 * @param form
 */
let clearError = (form) => {
    $(`.${errorSelector} .${elemErrorSelector}`, form).remove();
    $(`.${errorSelector}`, form).removeClass(errorSelector);
};

/**
 * Show server error
 * @param form
 * @param errors
 */
let showFormError = (form, errors) => {
    clearError(form);

    $.each(errors, (nameForm, list) => {
        $.each(list, (field, text) => {
            let name = `${nameForm}[${field}]`;
            let $field = $(`[name="${name}"]`, form);

            $field.addClass(errorSelector);

            if ($field.length) {
                $field.after(`<label id="${name}-error" class="${errorSelector} ${elemErrorSelector}" for="${name}">
                    <div class="error-inner">${text}</div>
                </label>`);
            }
        });
    });
};

/**
 * Show result after send
 * @param form
 * @param json
 * @param data
 * @param modalId
 */
let showResult = (form, json, data, modalId) => {
    const reset = form.data('reset') ? form.data('reset') : false;

    if (json.success) {
        if (reset) {
            $(form)[0].reset();
        }

        showModalNotification(data, modalId);
    } else if (Object.prototype.hasOwnProperty.call(json, 'errors')) {
        showFormError(form, json.errors);
    } else {
        showError();
    }
};

export {showResult};
